// app/javascript/controllers/section_template_controller.js
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["subsectionsContainer", "tablesContainer", "addSubsectionLink", "addTableLink", "toggleIcon", "sectionTitle", "collapsibleContent", "contentInput"]

  connect() {
    console.log("=== Section template controller connected ===")
    console.log("Element:", this.element)
    console.log("Has toggleIcon target:", this.hasToggleIconTarget)
    console.log("Has sectionTitle target:", this.hasSectionTitleTarget)
    console.log("Has collapsibleContent target:", this.hasCollapsibleContentTarget)
    console.log("Has contentInput target:", this.hasContentInputTarget)

    if (this.hasToggleIconTarget) {
      console.log("Toggle icon element:", this.toggleIconTarget)
    } else {
      console.error("Missing toggleIcon target!")
    }

    if (this.hasCollapsibleContentTarget) {
      console.log("Collapsible content element:", this.collapsibleContentTarget)
    } else {
      console.error("Missing collapsibleContent target!")
    }

    // Initialize as collapsed
    this.isCollapsed = true
    if (this.hasCollapsibleContentTarget && this.hasToggleIconTarget) {
      this.collapsibleContentTarget.style.display = 'none'
      this.toggleIconTarget.style.transform = 'rotate(-90deg)'
    }
    console.log("=== End connection ===")
  }

  toggleCollapse(event) {
    console.log("=== toggleCollapse called ===")
    console.log("Event:", event)
    console.log("Event target:", event.target)
    console.log("Current collapsed state:", this.isCollapsed)

    this.isCollapsed = !this.isCollapsed
    console.log("New collapsed state:", this.isCollapsed)

    console.log("Has collapsibleContent target:", this.hasCollapsibleContentTarget)
    console.log("Has toggleIcon target:", this.hasToggleIconTarget)

    if (this.hasCollapsibleContentTarget && this.hasToggleIconTarget) {
      console.log("Both targets found, proceeding with toggle")
      if (this.isCollapsed) {
        console.log("Collapsing...")
        this.collapsibleContentTarget.style.display = 'none'
        this.toggleIconTarget.style.transform = 'rotate(-90deg)'
        console.log("Collapsed - display:", this.collapsibleContentTarget.style.display)
      } else {
        console.log("Expanding...")
        this.collapsibleContentTarget.style.display = 'block'
        this.toggleIconTarget.style.transform = 'rotate(0deg)'
        console.log("Expanded - display:", this.collapsibleContentTarget.style.display)
      }
    } else {
      console.error("Missing targets!")
      if (!this.hasCollapsibleContentTarget) {
        console.error("Missing collapsibleContent target")
      }
      if (!this.hasToggleIconTarget) {
        console.error("Missing toggleIcon target")
      }
    }
    console.log("=== End toggleCollapse ===")
  }

  updateTitle(event) {
    console.log("=== updateTitle called ===")
    console.log("Has sectionTitle target:", this.hasSectionTitleTarget)
    if (this.hasSectionTitleTarget) {
      const title = event.target.value.trim()
      console.log("Updating title to:", title || "New Section")
      this.sectionTitleTarget.textContent = title || "New Section"
    } else {
      console.error("Missing sectionTitle target!")
    }
  }

  templateSelected(event) {
    console.log("Section template selected:", event.target.value)
    const templateKey = event.target.value
    if (!templateKey) return
    
    const jobId = event.target.dataset.jobId
    
    console.log("Fetching section template:", templateKey)
    
    fetch(`/job_report_builders/table_template?template_key=${templateKey}&job_id=${jobId}`)
      .then(response => {
        console.log("Response status:", response.status)
        return response.json()
      })
      .then(data => {
        console.log("Received template data:", data)
        
        if (data.section_template) {
          // Handle section template with subsections and/or tables
          this.applySectionTemplate(data)
        } else if (data.multiple_tables && data.tables) {
          // Handle multiple tables only (existing logic)
          this.createMultipleTables(data.tables)
        } else {
          // Handle single table (existing logic)
          this.createSingleTable(data)
        }
        
        // Reset the dropdown
        event.target.value = ''
      })
      .catch(error => {
        console.error("Fetch error:", error)
      })
  }

  applySectionTemplate(data) {
    console.log("Applying section template with subsections and tables")
    
    // Create subsections if any
    if (data.subsections && data.subsections.length > 0) {
      this.createSubsections(data.subsections)
    }
    
    // Create tables if any
    if (data.tables && data.tables.length > 0) {
      this.createTables(data.tables)
    }
  }

  createSubsections(subsections) {
    console.log(`Creating ${subsections.length} subsections`)
    
    if (!this.hasAddSubsectionLinkTarget) {
      console.error("Add Subsection link target not found")
      return
    }
    
    const addSubsectionLink = this.addSubsectionLinkTarget.querySelector('a.add_fields')
    
    if (!addSubsectionLink) {
      console.error("Could not find Add Subsection link inside target")
      return
    }
    
    subsections.forEach((subsectionData, index) => {
      setTimeout(() => {
        console.log(`Creating subsection ${index + 1}:`, subsectionData)
        
        addSubsectionLink.click()
        
        setTimeout(() => {
          const allSubsections = this.element.querySelectorAll('.grid.grid-cols-12.gap-2')
          const newestSubsection = allSubsections[allSubsections.length - 1]
          
          if (newestSubsection) {
            const contentField = newestSubsection.querySelector('textarea')
            if (contentField) {
              contentField.value = subsectionData.content
              console.log("Set content to:", subsectionData.content)
            }
            
            const nestingLevelField = newestSubsection.querySelector('select')
            if (nestingLevelField) {
              nestingLevelField.value = subsectionData.nesting_level || 1
              console.log("Set nesting level to:", subsectionData.nesting_level || 1)
            }
            
            // Set task_detail_id if provided
            if (subsectionData.task_detail_id) {
              const taskDetailIdField = newestSubsection.closest('.nested-fields').querySelector('.task-detail-id-field')
              if (taskDetailIdField) {
                taskDetailIdField.value = subsectionData.task_detail_id
                console.log("Set task_detail_id to:", subsectionData.task_detail_id)
              } else {
                console.warn("Could not find task_detail_id field")
              }
            }
            
            console.log(`Successfully created subsection: ${subsectionData.content}`)
          } else {
            console.error("Could not find newest subsection")
          }
        }, 400)
      }, index * 600)
    })
  }

  createTables(tables) {
    console.log(`Creating ${tables.length} tables`)
    
    if (!this.hasAddTableLinkTarget) {
      console.error("Add Table link target not found")
      return
    }
    
    const addTableLink = this.addTableLinkTarget.querySelector('a.add_fields')
    
    if (!addTableLink) {
      console.error("Could not find Add Table link inside target")
      return
    }
    
    tables.forEach((tableData, index) => {
      setTimeout(() => {
        console.log(`Creating table ${index + 1}:`, tableData.name)
        
        addTableLink.click()
        
        setTimeout(() => {
          const allTables = this.element.querySelectorAll('.nested-fields.mb-6 [data-controller="table-builder"]')
          const newestTable = allTables[allTables.length - 1]
          
          if (newestTable) {
            console.log("Found newest table:", newestTable)
            const tableController = this.application.getControllerForElementAndIdentifier(newestTable, 'table-builder')
            
            if (tableController) {
              console.log("Setting table data:", tableData)
              tableController.tableData = {
                headers: tableData.headers,
                rows: tableData.rows
              }
              tableController.renderTable()
              tableController.updateHiddenInput()
              
              if (tableData.name) {
                this.setTableName(newestTable, tableData.name)
              }
              
              console.log(`Successfully created table: ${tableData.name}`)
            } else {
              console.error("Could not get table controller")
            }
          } else {
            console.error("Could not find newest table")
          }
        }, 500)
      }, index * 800)
    })
  }

  createMultipleTables(tables) {
    this.createTables(tables)
  }

  createSingleTable(data) {
    console.log("Creating single table with data:", data)
    
    if (!this.hasAddTableLinkTarget) {
      console.error("Add Table link target not found")
      return
    }
    
    const addTableLink = this.addTableLinkTarget.querySelector('a.add_fields')
    
    if (!addTableLink) {
      console.error("Could not find Add Table link")
      return
    }
    
    // Always create a new table (don't check for existing tables)
    console.log("Creating new table")
    addTableLink.click()
    
    setTimeout(() => {
      // Search in entire element
      const allTables = this.element.querySelectorAll('.nested-fields.mb-6 [data-controller="table-builder"]')
      console.log("Tables after creation:", allTables.length)
      const newestTable = allTables[allTables.length - 1]
      
      if (newestTable) {
        console.log("Found new table:", newestTable)
        
        // Try multiple times to get the controller
        let attempts = 0
        const tryGetController = () => {
          attempts++
          const tableController = this.application.getControllerForElementAndIdentifier(newestTable, 'table-builder')
          
          if (tableController) {
            console.log("Setting new table data (attempt " + attempts + "):", data)
            tableController.tableData = {
              headers: data.headers,
              rows: data.rows
            }
            tableController.renderTable()
            tableController.updateHiddenInput()
            
            // Set the table name if provided
            if (data.name) {
              this.setTableName(newestTable, data.name)
            }
            
            console.log("Created and populated new table")
          } else if (attempts < 5) {
            console.log("Controller not ready, retrying... (attempt " + attempts + ")")
            setTimeout(tryGetController, 200)
          } else {
            console.error("Could not get controller for new table after 5 attempts")
          }
        }
        
        tryGetController()
      } else {
        console.error("Could not find newly created table")
      }
    }, 400)
  }

  setTableName(tableElement, name) {
    const tableContainer = tableElement.closest('.nested-fields.mb-6')
    
    if (tableContainer) {
      const nameInput = tableContainer.querySelector('input[placeholder="Table name"]')
      if (nameInput) {
        nameInput.value = name
        console.log("Set table name:", name)
      }
    }
  }
}